/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

 import { getTableFooterUtilityClass } from "@mui/material/TableFooter";
import { wc } from "@utdx/rotor-react-wc-shim";
 import { ReactNode, useEffect } from "react";
 import dashboardStyle from "../../styles/Dashboard.module.css";
 export function DashBoardWidget({
   header,
   icon,
   description,
   footer,
   footerStyle,
   iconsize,
 }: {
   header: string;
   icon: string;
   description: string | ReactNode;
   footer?: { title: string; onCLick: Function } | undefined;
   footerStyle?: string;
   iconsize?:string;
 }) {
   return (
     <>
       <div className={dashboardStyle.widgetContainer}>
         <div className={dashboardStyle.widgetHeader_Container}>
           <div className={dashboardStyle.widgetHeader}>{header}</div>
         </div>
         <div className={dashboardStyle.bodyContainer}>
        <div className={dashboardStyle.iconColor}> <rotor-icon
        ref={wc({
          
          icon: 'true',
          size: iconsize
        })}
        
        name={icon}>
          
      </rotor-icon> </div>
           <div className={dashboardStyle.descriptiontext}>
             {description}
           </div>
         </div>
         <div className={`${dashboardStyle.bottom_container} ${footerStyle}`} ><div
             onClick={() => {
               footer?.onCLick();
             }}
           >
             <div className={dashboardStyle.bottom}>
               {footer?.title}
               { !!footer && 
                 <rotor-icon 
                 name="arrow"
                 direction="left"
                 style={{ float: "right", marginRight: "18px", marginTop: "5px" }}              
               />
               }
             </div>
           </div>
           </div>
       </div>
     </>
   );
 }
 